module.exports = __webpack_public_path__ + "static/img/2.b2d47f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/price/2.png
// module id = I7m+
// module chunks = 1